/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invite_FooterInputs */

const en_invite_footer = /** @type {(inputs: Invite_FooterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions about this invite? Ask the person who sent it.`)
};

/** @type {(inputs: Invite_FooterInputs) => LocalizedString} */
const ar_invite_footer = en_invite_footer;

/** @type {(inputs: Invite_FooterInputs) => LocalizedString} */
const he_invite_footer = en_invite_footer;

/** @type {(inputs: Invite_FooterInputs) => LocalizedString} */
const ur_invite_footer = en_invite_footer;

/** @type {(inputs: Invite_FooterInputs) => LocalizedString} */
const es_invite_footer = en_invite_footer;

/** @type {(inputs: Invite_FooterInputs) => LocalizedString} */
const fr_invite_footer = en_invite_footer;

/** @type {(inputs: Invite_FooterInputs) => LocalizedString} */
const de_invite_footer = en_invite_footer;

/** @type {(inputs: Invite_FooterInputs) => LocalizedString} */
const pt_invite_footer = en_invite_footer;

/** @type {(inputs: Invite_FooterInputs) => LocalizedString} */
const hi_invite_footer = en_invite_footer;

/** @type {(inputs: Invite_FooterInputs) => LocalizedString} */
const bn_invite_footer = en_invite_footer;

/**
* | output |
* | --- |
* | "Questions about this invite? Ask the person who sent it." |
*
* @param {Invite_FooterInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const invite_footer = /** @type {((inputs?: Invite_FooterInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invite_FooterInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_invite_footer(inputs)
	if (locale === "he") return he_invite_footer(inputs)
	if (locale === "ur") return ur_invite_footer(inputs)
	if (locale === "es") return es_invite_footer(inputs)
	if (locale === "fr") return fr_invite_footer(inputs)
	if (locale === "de") return de_invite_footer(inputs)
	if (locale === "pt") return pt_invite_footer(inputs)
	if (locale === "hi") return hi_invite_footer(inputs)
	if (locale === "bn") return bn_invite_footer(inputs)
	return /** @type {LocalizedString} */ ("Questions about this invite? Ask the person who sent it.")
});